
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"matrix(2,0,0,2,0,0)"}},[_c('defs',[_c('style',[_v('.a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}')])]),_c('title',[_v('smiley-bad')]),_c('circle',{staticClass:"a",attrs:{"cx":"12","cy":"12","r":"11.25"}}),_c('path',{staticClass:"a",attrs:{"d":"M15.665,18.75a.76.76,0,0,0,.744-.9,4.5,4.5,0,0,0-8.818,0,.759.759,0,0,0,.744.9Z"}}),_c('polyline',{staticClass:"a",attrs:{"points":"6.75 6.75 9.75 9.75 6 9.75"}}),_c('polyline',{staticClass:"a",attrs:{"points":"17.25 6.75 14.25 9.75 18 9.75"}})])])
          )
        }
      }
    